export default __webpack_public_path__ + "static/media/digiConsent.5596c56a.png";